module.exports = __webpack_public_path__ + "static/media/26114210_1406381776156172_758146053707035878_n.1a718249.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage/26114210_1406381776156172_758146053707035878_n.jpg
// module id = 218
// module chunks = 0